module.exports = __webpack_public_path__ + "media/reskin-images/icon--search-bf7e7958.svg";